import { Modal } from "~/jose_modern/modal.js";
import { once } from "~/jose_modern/once.js";

const MODAL_SELECTOR = "#rename-inventory-modal";

function bindEditLink(container = document) {
  const link = container.querySelector("#inventory-name-edit-link");
  if (!link) return;

  once(link, "inventory-rename-open", (el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
      Modal.show(MODAL_SELECTOR);
    });
  });
}

export function initInventoryNameModal() {
  const modal = document.querySelector(MODAL_SELECTOR);
  if (!modal) return;

  const input = modal.querySelector("#inventory-custom-name-input");
  const resetButton = modal.querySelector("#inventory-custom-name-reset");
  const form = modal.querySelector("form");

  bindEditLink();
  document.addEventListener("partial:replace", (ev) => bindEditLink(ev.container));

  resetButton.addEventListener("click", () => {
    input.value = "";
    input.focus();
  });

  modal.addEventListener("modal:close", () => form?.reset());

  document.addEventListener("inventory:custom-name-updated", (ev) => {
    input.defaultValue = ev.detail;
    document
      .querySelectorAll("[data-inventory-display-name]")
      .forEach((el) => (el.textContent = ev.detail));
    document.title = `History ${ev.detail} - ReciPal`;

    Modal.hide(MODAL_SELECTOR);
  });
}
